import { render, staticRenderFns } from "./ReplicationMenu.vue?vue&type=template&id=26732571&"
import script from "./ReplicationMenu.vue?vue&type=script&lang=js&"
export * from "./ReplicationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26732571')) {
      api.createRecord('26732571', component.options)
    } else {
      api.reload('26732571', component.options)
    }
    module.hot.accept("./ReplicationMenu.vue?vue&type=template&id=26732571&", function () {
      api.rerender('26732571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ReplicationMenu.vue"
export default component.exports